import { render, staticRenderFns } from "./CourseCardsFiltersInSidebar.vue?vue&type=template&id=0cb7b5b6&"
import script from "./CourseCardsFiltersInSidebar.vue?vue&type=script&lang=js&"
export * from "./CourseCardsFiltersInSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports